<script>
import {mapGetters, mapMutations} from 'vuex'
export default {
	computed: {
		...mapGetters({
			userName: 'auth/userName'
		})
	},

	methods: {
		async logout() {
			const vm = this
			await vm.removeUser()
			vm.$router.push({ name: 'register' })
		},
		...mapMutations({
			removeUser: 'auth/removeUser'
		})
	}
}
</script>
<template>
	<header class="header">
		<div class="header__nav container-fluid px-2">
			<div>
				<span class="mr-2">{{userName}}</span>
				<button class="text-white btn btn-link" @click="logout"><i class="fa fa-power-off" aria-hidden="true"></i></button>
			</div>
		</div>
	</header>
</template>

<style lang="scss" scoped>
.header{
	color: #fff;
	min-height: 60px;
	&__nav{
		display: flex;
		justify-content: flex-end;
		padding: 0.5em 0 ;
	}

}
</style>